import { ObjectSchema, mixed, object, string } from 'yup';
import { Deductible, PaymentMode } from '../enums';
import { PlanFormValues } from '../types/form';

export const planSchema: ObjectSchema<PlanFormValues> = object({
  planCode: string().required(),
  paymentMode: mixed<PaymentMode>().required(),
  deductible: mixed<Deductible>().required(),
});
